// «التحليل الذكي» test ids (E2E suite on branch `e2e`).
export const AI = {
    page: "ai-page",
    keyMissing: "ai-key-missing",
    running: "ai-running",
    runBtn: "ai-run-now",
    runPeriod: "ai-run-period",
    cooldown: "ai-cooldown",
    briefSelect: "ai-brief-select",
    briefMeta: "ai-brief-meta",
    empty: "ai-empty",
    failed: "ai-failed",
    failedItem: "ai-failed-item",
    partMissing: "ai-part-missing",
    notWritten: "ai-not-written",
    historyPartial: "ai-history-partial",
    tab: (k) => `ai-tab-${k}`,
    executive: "ai-executive",
    headline: "ai-headline",
    point: "ai-point",
    advice: "ai-advice",
    adviceCard: (i) => `ai-advice-${i}`,
    adviceSuperOnly: "ai-advice-super-only",
    modules: "ai-modules",
    module: (k) => `ai-module-${k}`,
    branchSelect: "ai-branch-select",
    branch: "ai-branch",
    quality: "ai-quality",
    caveat: "ai-caveat",
    history: "ai-history",
    historyRow: (id) => `ai-history-${id}`,
    figure: "ai-figure",
    flag: "ai-flag",
    settings: "ai-settings",
    settingsSave: "ai-settings-save",
};
